import {
  GCM_OPT_IN_DEFAULTS,
  GCM_OPT_OUT_DEFAULTS,
} from 'constants/gcm'

import CurrentRegionSettings from 'constants/current-region-settings'

import GTM from 'utils/gtm'


export default function sendGCMConsentDefaults() {
  if ( window.TERMLY_FORCE_DISABLE_GCM ) {
    console.debug('[Termly] Not sending GCM consent defaults '
                  + '(found window.TERMLY_FORCE_DISABLE_GCM = %o)',
                  window.TERMLY_FORCE_DISABLE_GCM)
    return
  }

  if ( !CurrentRegionSettings.isInitialized() ) {
    console.debug('[Termly] Cannot set GCM consent defaults: region settings have not yet been initialized.')
    return
  }

  const defaults = getDefaults()

  GTM.sendConsentDefault(defaults)
}

function getDefaults() {
  const gcmSettings = CurrentRegionSettings.getGoogleConsentModeSettings()

  if ( gcmSettings ) {
    console.debug('[Termly] Using GCM defaults from dashboard region configuration')
    return getGCMRegionSettings(gcmSettings)
  }

  if ( CurrentRegionSettings.isOptOut() ) {
    console.debug('[Termly] Using standard GCM opt-out defaults')
    return GCM_OPT_OUT_DEFAULTS
  }

  console.debug('[Termly] Using standard GCM opt-in defaults')
  return GCM_OPT_IN_DEFAULTS
}

function getGCMRegionSettings(settings) {
  const {
    enable_wait_for_update: enableWaitForUpdate,
    ...gcmSettings
  } = settings

  if ( !enableWaitForUpdate ) {
    delete gcmSettings.wait_for_update
  }

  return gcmSettings
}
